var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9112E183-27C1-4337-8D1A-D7D4028F10A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,-3.55271368e-15 C12.6521649,-3.55271368e-15 15.195704,1.0535684 17.0710678,2.92893219 C18.9464316,4.80429597 20,7.3478351 20,10 C20,12.6521649 18.9464316,15.195704 17.0710678,17.0710678 C15.195704,18.9464316 12.6521649,20 10,20 C7.3478351,20 4.80429597,18.9464316 2.92893219,17.0710678 C1.0535684,15.195704 -3.55271368e-15,12.6521649 -3.55271368e-15,10 C-3.55271368e-15,4.4771525 4.4771525,-3.55271368e-15 10,-3.55271368e-15 Z M14.3858353,7.12413252 C13.9435527,6.68189293 13.2265417,6.68189293 12.7842591,7.12413252 L12.7842591,7.12413252 L9.0565566,10.8522273 L7.5930994,9.38815768 C7.15081682,8.9459181 6.43380581,8.9459181 5.99152323,9.38815768 C5.5499954,9.83039726 5.5499954,10.5473386 5.99152323,10.9895781 L5.99152323,10.9895781 L8.25576852,13.2536033 C8.47690981,13.4747231 8.76673321,13.5849057 9.0565566,13.5849057 C9.34638,13.5849057 9.6362034,13.4747231 9.85734468,13.2536033 L9.85734468,13.2536033 L14.3858353,8.72555298 C14.8273631,8.2833134 14.8273631,7.5663721 14.3858353,7.12413252 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.800000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion_2",
    transform: "translate(-264.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-9",
    transform: "translate(172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy",
    transform: "translate(62.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.76a4a9a8bae57cbfa80c0663b931f648.svg";
export { ForwardRef as ReactComponent };